import { Component, Input } from '@angular/core';
import { environment } from '@environments';


@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html'
})
export class AnnouncementComponent {
  @Input() productData: any;
	public imageUrl: string = environment.imageUrl;

  linkClick(url:string){
    // Check if the URL starts with "http://" or "https://"
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      // If it doesn't start with either, add "http://" to the URL
      url = 'http://' + url;
    }
    // Open the URL in a new tab
    window.open(url, '_blank');
  }
}
